import { Component } from "react";
import * as React from "react";
import { SectionHeader } from "../components/visual/SectionHeader";

import { ALL_PRODUCTS } from "../api/models/Product";
import { ProductCarousel } from "../components/product/ProductCarousel";

import bgWhiteDirt from "../images/bgWhiteDirt.jpg";
import shells1 from "../images/products/msl1.jpg"

import { primary } from "src/styles/Colors";

import { Link } from "react-router-dom";
import * as instagram from "../images/instagram.svg";
import bg from "../images/dark_wall.png";
import {ImageWithText} from "../components/visual/ImageWithText";
import mslTacticalPlusDemo from "../images/products/msl_tactical_plus_demo.jpg";
import mslTacticalComparison from "../images/products/msl_tactical_comparison.jpg";

export class HomeView extends Component {
    public render() {
        return (
            <div>
                <section>
                    <div style={{ height: "490px", backgroundSize: "cover", backgroundImage: `url(${shells1})`, backgroundPosition: "center" }}/>
                </section>
                <section style={{ marginTop: "5rem", marginBottom: "5rem", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <SectionHeader title="Schnell-Lader" subtitle="in Action" titleColor={primary} subtitleColor="white"/>
                    <iframe width="1120" height="630" src="https://www.youtube.com/embed/Tzn7LFdsWWw" frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen={true}/>

                            <p style={{marginTop: "2rem", color: "white"}}>Weiter Bilder und Videos finden Sie auf Instagram: </p>
                    <a href="https://www.instagram.com/msl_magnet_schnell_lader/">
                        <img src={instagram}/>
                    </a>
                </section>
                <div id={"new-tactical"} style={{ backgroundImage: `url(${bg})`, paddingTop: "3rem", paddingBottom: "3rem" }}>
                    <div className="grid-container text-center" style={{ marginBottom: "2rem" }}>
                        <h2>Jetzt <b>Neu</b></h2>
                        <hr className="color-neutral" style={{ borderWidth: ".125rem" }}/>
                        <p className="white" style={{fontSize: "2rem"}}>
                            Der MSL Tactical und MSL Tactical Plus
                        </p>
                    </div>
                    <ImageWithText imagePosition="left" imgSrc={mslTacticalPlusDemo} header="MSL Tactical" text={[
                        "Der MSL Sport besitzt eine Haftkraft von ca. 2,7 kg, der MSL Tactical hingegen eine Haftkraft von ca. 8 kg.",
                        "Somit hält der MSL Tactical auch in einem Flintenschaftetui, auch beim Verschießen von Brenneke Flintenlaufgeschossen."
                    ]} style={{ marginBottom: "1rem" }}/>
                    <ImageWithText imagePosition="right" imgSrc={mslTacticalComparison} header="MSL Tactical Plus" soldOut={true} text={[
                        "Der MSL Tactical Plus verfügt ebenfalls über eine erhöhte Haftkraft von ca. 8 kg.",
                        "Außerdem ermöglicht der Höhenunterschied ein vereinfachtes Einführen der Schrotpatronen.",
                    ]} style={{ marginBottom: "2rem" }}/>
                </div>
                <section style={{ backgroundImage: `url(${bgWhiteDirt})`, paddingTop: "3rem", paddingBottom: "3rem" }}>
                    <div className="grid-container">
                        <SectionHeader title="Unsere Produkte" subtitle="Bestellen Sie sich jetzt ihren Speed-Loader!" titleColor={primary} subtitleColor="black"/>
                        <ProductCarousel products={ALL_PRODUCTS} style={{ marginTop: "1rem", marginBottom: "3rem" }}/>
                        <Link to="/order" className="button" style={{ backgroundColor: "#FF8800", margin: 0, display: "block", fontSize: "1.125rem", letterSpacing: ".2rem", color: "#050505" }}><b>JETZT BESTELLEN</b></Link>
                    </div>
                </section>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/HomeView.tsx